import "./pedagdocimagefolder.css";
import React, { Component } from "react";
import { StateContext } from "../../../State";
import { downloadBase64File } from "../../../utils";
import { ServerApi } from "../../../internal";
import PedagDocImageFolderViewManager from "./PedagDocImageFolderViewManager";
import ContentBoxMUI from "../../../Components/ContentBoxMUI";
import ImageThumbnail from "./Components/PedagDocImageThumbnail";
import { Redirect } from "react-router-dom";

class PedagDocImageFolder extends Component {
  static contextType = StateContext;

  constructor(props) {
    super(props);
    this.state = {
      download: false,
      selectedImages: [],
      childId: this.props.location?.state?.childId ?? null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const state = this.props.location?.state;
    if (!state || !state.childId || !state.folder) {
      this.props.history.push("/growthfolder");
      return;
    }

    this.context.actions.triggerLoadImages({
      childId: state.childId,
      folder: state.folder.Id,
    });
  }

  renderImageThumbnail = (image) => {
    return (
      <ImageThumbnail
        key={image.Id}
        image={image}
        isSelected={this.state.selectedImages.includes(image.Id)}
        onClick={this.handleClick}
      />
    );
  };

  handleClick = (Id) => {
    if (this.state.download && !this.state.selectedImages.includes(Id)) {
      this.state.selectedImages.push(Id);
    } else if (this.state.download && this.state.selectedImages.includes(Id)) {
      const index = this.state.selectedImages.indexOf(Id);
      if (index > -1) {
        this.state.selectedImages.splice(index, 1);
      }
    } else {
      this.props.history.push("/growthfolder/media", {
        Id: Id,
        childId: this.props.location.state.childId,
      });
    }
  };

  changeMode = () => {
    if (this.state.download === false) {
      this.setState((state) => {
        return { download: true };
      });
    } else if (this.state.download === true) {
      this.setState((state) => {
        return {
          download: false,
          selectedImages: [],
        };
      });
    }
  };

  downloadFiles = async () => {
    this.setState((state) => {
      return { loading: true };
    });
    if (
      this.state.selectedImages === null ||
      this.state.selectedImages.length === 0
    ) {
      this.setState((state) => {
        return { loading: false };
      });
      this.changeMode();
    }

    //TÄNNE LISÄYS!
    else {
      const response = await new ServerApi().loadDownloadImages({
        ChildId: this.props.location.state.childId,
        imageIds: this.state.selectedImages,
      });
      //if(response) {
      if (!response) {
        this.setState((state) => {
          return { loading: false };
        });
        this.changeMode();
      } else {
        response.data.map((img) => {
          downloadBase64File(img.Data, img.MimeType, img.FileName);
        });
        this.setState(() => {
          return { loading: false };
        });
        this.changeMode();
      }
    }
  };

  reloadFoldersIfFailed = () => {
    this.context.actions.triggerLoadImages({
      childId: this.props.location.state.childId,
      folder: this.props.location.state.folder.Id,
    });
  };

  render() {
    const locationState = this.props.location?.state;
    //have to guard else breaks on refresh (no folder in props)
    if (!locationState || !locationState.folder) {
      return <Redirect to="/growthfolder" />;
    }
    const { growthFolder } = this.context.state;
    const imageFolderFunctions = {
      reloadFoldersIfFailed: this.reloadFoldersIfFailed,
      renderImageThumbnail: this.renderImageThumbnail,
      changeMode: this.changeMode,
      downloadFiles: this.downloadFiles,
    };

    return (
      <ContentBoxMUI>
        <PedagDocImageFolderViewManager
          imagefolderState={this.state}
          growthfolderState={growthFolder}
          imageFolderFunctions={imageFolderFunctions}
          imageFolderInformation={locationState.folder}
          errorCode={growthFolder.errorCode}
        />
      </ContentBoxMUI>
    );
  }
}

export default PedagDocImageFolder;
